import { render, staticRenderFns } from "./DetailSkeleton.vue?vue&type=template&id=4f868304"
import script from "./DetailSkeleton.vue?vue&type=script&lang=js"
export * from "./DetailSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports